<template>
  <div class="page-content">
    <div class="content">
      <h1 class="page-title">{{ $t('roadmap.title') }}</h1>
      <div class="intro-section">
        <img
          src="../assets/img/fazhanluxian.png"
          alt="发展路线图"
          class="section-image"
        />
        <div class="article">
          <p>{{ $t('roadmap.description') }}</p>
          <div class="roadmap-list">
            <div class="roadmap-item">
              <h3>{{ $t('roadmap.phase1.title') }}</h3>
              <p>{{ $t('roadmap.phase1.content') }}</p>
            </div>
            <div class="roadmap-item">
              <h3>{{ $t('roadmap.phase2.title') }}</h3>
              <p>{{ $t('roadmap.phase2.content') }}</p>
            </div>
            <div class="roadmap-item">
              <h3>{{ $t('roadmap.phase3.title') }}</h3>
              <p>{{ $t('roadmap.phase3.content') }}</p>
            </div>
            <div class="roadmap-item">
              <h3>{{ $t('roadmap.phase4.title') }}</h3>
              <p>{{ $t('roadmap.phase4.content') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Roadmap',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
};
</script>

<style scoped>
.page-content {
  min-height: calc(100vh - 160px);
  width: 100%;
  padding: 0;
  background: var(--bg-primary);
}

.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  background: var(--bg-primary);
}

.page-title {
  font-size: 42px;
  line-height: 56px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--accent-primary);
}

.intro-section {
  margin-top: 30px;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.article {
  font-size: 18px;
  line-height: 36px;
  color: var(--text-secondary);
  text-align: justify;
  padding: 0 10px 30px;
  width: 100%;
}

.article p {
  margin-bottom: 20px;
}

.roadmap-list {
  margin-top: 50px;
  position: relative;
}

.roadmap-item {
  position: relative;
  padding: 30px 30px 30px 80px;
  margin-bottom: 40px;
  background: var(--bg-card);
  border-radius: 8px;
  border-left: 4px solid var(--accent-primary);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.roadmap-item:hover {
  transform: translateX(10px);
  box-shadow: var(--shadow-lg);
  background: var(--bg-card-hover);
}

.roadmap-item::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 35px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-primary);
  border: 4px solid var(--bg-card);
  box-shadow: 0 0 0 4px var(--accent-primary);
  z-index: 2;
}

.roadmap-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 29px;
  top: 55px;
  width: 2px;
  height: calc(100% + 20px);
  background: var(--accent-primary);
  z-index: 1;
}

.roadmap-item h3 {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 15px;
}

.roadmap-item p {
  margin-bottom: 0;
  line-height: 28px;
  font-size: 16px;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .content {
    width: 100%;
    padding: 20px 15px;
  }

  .page-title {
    font-size: 28px;
    line-height: 36px;
  }

  .article {
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px 20px;
  }

  .roadmap-item {
    padding: 20px 20px 20px 60px;
  }

  .roadmap-item::before {
    left: 15px;
    width: 15px;
    height: 15px;
  }

  .roadmap-item:not(:last-child)::after {
    left: 22px;
  }

  .roadmap-item h3 {
    font-size: 20px;
  }
}
</style>
